var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1109px",
    height: "1109px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#010101",
    d: "M 48.5,-0.5 C 330.167,-0.5 611.833,-0.5 893.5,-0.5C 900.671,4.15583 907.171,9.82249 913,16.5C 964.667,70.1667 1016.33,123.833 1068,177.5C 1068.5,269.499 1068.67,361.499 1068.5,453.5C 1061.83,453.5 1055.17,453.5 1048.5,453.5C 1048.67,364.166 1048.5,274.833 1048,185.5C 994.47,130.971 941.303,76.1374 888.5,21C 612.167,20.5 335.834,20.3333 59.5,20.5C 59.5,164.833 59.5,309.167 59.5,453.5C 52.8333,453.5 46.1667,453.5 39.5,453.5C 39.3333,304.166 39.5,154.833 40,5.5C 41.9425,2.12205 44.7759,0.122045 48.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9d9d9",
    d: "M 1048.5,453.5 C 718.833,453.5 389.167,453.5 59.5,453.5C 59.5,309.167 59.5,164.833 59.5,20.5C 335.834,20.3333 612.167,20.5 888.5,21C 941.303,76.1374 994.47,130.971 1048,185.5C 1048.5,274.833 1048.67,364.166 1048.5,453.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#060606",
    d: "M 901.5,50.5 C 901.5,92.1667 901.5,133.833 901.5,175.5C 941.167,175.5 980.833,175.5 1020.5,175.5C 1026.06,176.223 1029.06,179.39 1029.5,185C 1028.99,190.515 1025.99,193.849 1020.5,195C 976.833,195.667 933.167,195.667 889.5,195C 885.23,193.73 882.73,190.896 882,186.5C 881.333,140.833 881.333,95.1667 882,49.5C 885.422,42.7043 890.589,40.871 897.5,44C 899.734,45.6379 901.067,47.8045 901.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b4b4b",
    d: "M 128.5,136.5 C 347.167,136.333 565.834,136.5 784.5,137C 793.52,139.867 795.687,145.367 791,153.5C 789.581,154.46 788.081,155.293 786.5,156C 566.833,156.667 347.167,156.667 127.5,156C 121.533,152.608 120.033,147.774 123,141.5C 124.73,139.598 126.563,137.931 128.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#858585",
    d: "M 901.5,50.5 C 902.499,91.6633 902.832,132.997 902.5,174.5C 942.004,174.168 981.337,174.501 1020.5,175.5C 980.833,175.5 941.167,175.5 901.5,175.5C 901.5,133.833 901.5,92.1667 901.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b4b4b",
    d: "M 128.5,236.5 C 415.167,236.333 701.834,236.5 988.5,237C 997.352,239.855 999.518,245.355 995,253.5C 993.581,254.46 992.081,255.293 990.5,256C 702.833,256.667 415.167,256.667 127.5,256C 121.533,252.608 120.033,247.774 123,241.5C 124.73,239.598 126.563,237.931 128.5,236.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b4b4b",
    d: "M 128.5,336.5 C 415.167,336.333 701.834,336.5 988.5,337C 995.945,339.392 998.445,344.225 996,351.5C 994.457,353.378 992.624,354.878 990.5,356C 702.833,356.667 415.167,356.667 127.5,356C 121.533,352.608 120.033,347.774 123,341.5C 124.73,339.598 126.563,337.931 128.5,336.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dc0011",
    d: "M -0.5,453.5 C 12.8333,453.5 26.1667,453.5 39.5,453.5C 46.1667,453.5 52.8333,453.5 59.5,453.5C 389.167,453.5 718.833,453.5 1048.5,453.5C 1055.17,453.5 1061.83,453.5 1068.5,453.5C 1081.83,453.5 1095.17,453.5 1108.5,453.5C 1108.5,604.5 1108.5,755.5 1108.5,906.5C 1095.17,906.5 1081.83,906.5 1068.5,906.5C 1062.02,905.509 1055.35,905.176 1048.5,905.5C 712,905.167 375.666,905.5 39.5,906.5C 26.1667,906.5 12.8333,906.5 -0.5,906.5C -0.5,755.5 -0.5,604.5 -0.5,453.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefcfc",
    d: "M 203.5,546.5 C 245.835,546.333 288.168,546.5 330.5,547C 351.298,547.929 369.798,554.762 386,567.5C 409.027,594.665 414.027,624.999 401,658.5C 392.421,679.413 377.254,692.913 355.5,699C 347.63,701.301 339.63,702.967 331.5,704C 300.858,705.418 270.192,705.918 239.5,705.5C 239.5,741.5 239.5,777.5 239.5,813.5C 227.5,813.5 215.5,813.5 203.5,813.5C 203.5,724.5 203.5,635.5 203.5,546.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefcfc",
    d: "M 452.5,546.5 C 495.183,546.095 537.85,546.595 580.5,548C 618.572,553.734 645.406,574.234 661,609.5C 673.206,641.153 676.873,673.82 672,707.5C 668.118,740.43 654.285,768.263 630.5,791C 611.072,804.616 589.406,811.949 565.5,813C 527.835,813.5 490.168,813.667 452.5,813.5C 452.5,724.5 452.5,635.5 452.5,546.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfb",
    d: "M 723.5,546.5 C 783.833,546.5 844.167,546.5 904.5,546.5C 904.5,557.167 904.5,567.833 904.5,578.5C 856.167,578.5 807.833,578.5 759.5,578.5C 759.5,605.833 759.5,633.167 759.5,660.5C 801.167,660.5 842.833,660.5 884.5,660.5C 884.5,671.167 884.5,681.833 884.5,692.5C 842.833,692.5 801.167,692.5 759.5,692.5C 759.5,732.833 759.5,773.167 759.5,813.5C 747.5,813.5 735.5,813.5 723.5,813.5C 723.5,724.5 723.5,635.5 723.5,546.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dd0111",
    d: "M 239.5,578.5 C 269.502,578.333 299.502,578.5 329.5,579C 356.912,582.299 370.579,597.799 370.5,625.5C 370.65,651.365 357.983,666.532 332.5,671C 324.869,672.04 317.202,672.706 309.5,673C 286.169,673.5 262.836,673.667 239.5,673.5C 239.5,641.833 239.5,610.167 239.5,578.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dd0011",
    d: "M 488.5,578.5 C 516.857,578.099 545.191,578.599 573.5,580C 591.527,582.092 606.027,590.259 617,604.5C 628.35,619.522 634.683,636.522 636,655.5C 638.078,680.204 636.078,704.537 630,728.5C 622.003,758.835 602.503,776.002 571.5,780C 543.859,781.408 516.192,781.908 488.5,781.5C 488.5,713.833 488.5,646.167 488.5,578.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.97
    },
    fill: "#030202",
    d: "M 1048.5,905.5 C 1055.35,905.176 1062.02,905.509 1068.5,906.5C 1068.67,970.834 1068.5,1035.17 1068,1099.5C 1067.17,1101.67 1065.67,1103.17 1063.5,1104C 893.722,1105.16 723.888,1105.66 554,1105.5C 384.112,1105.66 214.278,1105.16 44.5,1104C 42.6217,1102.46 41.1217,1100.62 40,1098.5C 39.5,1034.5 39.3333,970.501 39.5,906.5C 46.1667,906.5 52.8333,906.5 59.5,906.5C 59.1676,966.002 59.5009,1025.34 60.5,1084.5C 389.833,1084.5 719.167,1084.5 1048.5,1084.5C 1048.5,1025.17 1048.5,965.833 1048.5,906.5C 1048.5,906.167 1048.5,905.833 1048.5,905.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9d9d9",
    d: "M 1048.5,906.5 C 1048.5,965.833 1048.5,1025.17 1048.5,1084.5C 719.167,1084.5 389.833,1084.5 60.5,1084.5C 60.5,1025.17 60.5,965.833 60.5,906.5C 389.833,906.5 719.167,906.5 1048.5,906.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b88c8d",
    d: "M 39.5,906.5 C 375.666,905.5 712,905.167 1048.5,905.5C 1048.5,905.833 1048.5,906.167 1048.5,906.5C 719.167,906.5 389.833,906.5 60.5,906.5C 60.5,965.833 60.5,1025.17 60.5,1084.5C 59.5009,1025.34 59.1676,966.002 59.5,906.5C 52.8333,906.5 46.1667,906.5 39.5,906.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b4b4b",
    d: "M 128.5,966.5 C 415.167,966.333 701.834,966.5 988.5,967C 995.945,969.392 998.445,974.225 996,981.5C 994.457,983.378 992.624,984.878 990.5,986C 702.833,986.667 415.167,986.667 127.5,986C 121.533,982.608 120.033,977.774 123,971.5C 124.73,969.598 126.563,967.931 128.5,966.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/Pdf.f2643d3c3ef1213f0839ad63841e391f.svg";
export { ForwardRef as ReactComponent };